import React, { createContext, useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { getAllUsers } from '../services/usersService';
import Notification from '../components/Common/Notification';

// Create the context
export const AllUsersContext = createContext();

// Provider component
export const AllUsersProvider = ({ children }) => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const [users, setUsers] = useState([]);
  const [notification, setNotification] = useState({ message: '', isError: false });

  // Fetch authentication headers with the token
  const fetchAuthHeaders = () => {
    const storedUser = localStorage.getItem('user');
    const token = user?.token || (storedUser ? JSON.parse(storedUser).token : '');

    if (!token) {
      console.error('User or token not available');
      return {};
    }

    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  };

  // Function to display notifications
  const showNotification = (message, isError) => {
    setNotification({ message, isError });
  };

  // Function to close notifications
  const closeNotification = () => {
    setNotification({ message: '', isError: false });
  };

  // Function to fetch all users
  const fetchAllUsers = async () => {
    try {
      const authHeaders = fetchAuthHeaders();
      const data = await getAllUsers(authHeaders);
      setUsers(data);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        'Error fetching users.';
      showNotification(errorMessage, true);
    }
  };

  // useEffect(() => {
  //   fetchAllUsers();
  // }, []);


  useEffect(() => {
    if (!isAuthenticated && !['/', '/login'].includes(window.location.pathname)) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);


  return (
    <AllUsersContext.Provider
      value={{
        users,
        fetchAllUsers,
      }}
    >
      {children}
      {notification.message && (
        <Notification
          message={notification.message}
          isError={notification.isError}
          onClose={closeNotification}
        />
      )}
    </AllUsersContext.Provider>
  );
};

// Custom hook to use the AllUsersContext
export const useAllUsers = () => useContext(AllUsersContext);
